import axios from "../api";
import { CRYPTO_TOKEN_SECRET_KEY } from "../config";
import CryptoJS from "crypto-js";

const getAuthToken = () => {
  const decryptedData = CryptoJS.AES.decrypt(localStorage.getItem("token"), CRYPTO_TOKEN_SECRET_KEY).toString(CryptoJS.enc.Utf8);
  return decryptedData;
};

export const deleteMultipleLogsAction = async (data) => {
  const authToken = getAuthToken();
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  return new Promise((resolve, reject) => {
    axios
      .post(`/api/audit-trail`, data, {
        headers: headers,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const deleteLogsByIdAction = async (id) => {
  const authToken = getAuthToken();
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  return new Promise((resolve, reject) => {
    axios
      .delete(`/api/audit-trail/single-delete/${id}`, {
        headers: headers,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const logsFilterAction = async (searchValue, page, pageSize, type, userOperation, moduleId, startDate, endDate, userNameFilter) => {
  const authToken = getAuthToken();
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  let apiUrl = `/api/audit-trail?page=${page}&pageSize=${pageSize}&type=${type}&userOperation=${userOperation}&moduleId=${moduleId}&userNameFilter=${userNameFilter}`;
  if (startDate && endDate) {
    apiUrl += `&startDate=${startDate}&endDate=${endDate}`;
  }
  if (searchValue) {
    apiUrl += `&searchValue=${searchValue}`;
  }
  return new Promise((resolve, reject) => {
    axios
      .get(apiUrl, {
        headers: headers,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getModulesOptionsActions = async () => {
  //   const authToken = getAuthToken();
  //   const headers = {
  //     Authorization: `Bearer ${authToken}`,
  //   };
  let apiUrl = `/api/audit-trail/modules-option`;

  return new Promise((resolve, reject) => {
    axios
      .get(apiUrl)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getAllUsersDataAction = async () => {
  const authToken = getAuthToken();
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  return new Promise((resolve, reject) => {
    axios
      .get(`/api/log/get-all-users`, {
        headers: headers,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const exportSystemLogDataAction = async (searchValue, page, pageSize, userOperation, moduleName, startDate, endDate, userNameFilter, data) => {
  const authToken = getAuthToken();
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  let apiUrl = `/api/log/export-system-log?page=${page}&pageSize=${pageSize}&userOperation=${userOperation}&moduleName=${moduleName}&userNameFilter=${userNameFilter}`;
  if (startDate && endDate) {
    apiUrl += `&startDate=${startDate}&endDate=${endDate}`;
  }
  if (searchValue) {
    apiUrl += `&searchValue=${searchValue}`;
  }
  return new Promise((resolve, reject) => {
    axios
      .post(
        apiUrl,
        { ids: data },
        {
          headers: headers,
          responseType: "blob", // Set responseType to 'blob'
        }
      )
      .then((response) => {
        resolve(response.data); // Resolve with blob data
      })
      .catch((error) => {
        reject(error);
      });
  });
};
